import React from 'react';

const NotFound = () => (
    <div id='content'>
        <div className='error contentPanel'>Page not found</div>
    </div>
);

export default NotFound;
